// ═══════════════════════════════════════════════════════════════
// XYQAR — Onboarding Wizard Step Definitions (SPEC SITE 4)
// ═══════════════════════════════════════════════════════════════
export type Persona = 'client' | 'talent' | 'partner';

export interface StepDef {
  slug:  string;
  title: string;
  num:   number;
  total: number;
}

export const CLIENT_STEPS: StepDef[] = [
  { slug: 'identity',   title: 'Identity',                num: 1, total: 8 },
  { slug: 'company',    title: 'Company',                 num: 2, total: 8 },
  { slug: 'intake',     title: 'Mode (On-Demand / Emergency / Pool)', num: 3, total: 8 },
  { slug: 'upload',     title: 'Brief upload',            num: 4, total: 8 },
  { slug: 'compliance', title: 'NIS2 / ISO27001 / SecNumCloud', num: 5, total: 8 },
  { slug: 'tech',       title: 'Required stack',          num: 6, total: 8 },
  { slug: 'timeline',   title: 'Timeline & location',     num: 7, total: 8 },
  { slug: 'output',     title: 'Pre-matched candidates',  num: 8, total: 8 },
];

export const TALENT_STEPS: StepDef[] = [
  { slug: 'identity',     title: 'KYC identity',          num: 1, total: 7 },
  { slug: 'cv',           title: 'CV upload',             num: 2, total: 7 },
  { slug: 'skills',       title: 'Expertises',            num: 3, total: 7 },
  { slug: 'certifs',      title: 'ANSSI / CREST certifications', num: 4, total: 7 },
  { slug: 'tests',        title: 'XYQAR SaaS tests (4)',  num: 5, total: 7 },
  { slug: 'availability', title: 'Availability & TJM',    num: 6, total: 7 },
  { slug: 'prefs',        title: 'Sector & geo preferences', num: 7, total: 7 },
];

export const PARTNER_STEPS: StepDef[] = [
  { slug: 'company',     title: 'Company',                num: 1, total: 5 },
  { slug: 'pool',        title: 'Talent pool (CSV / manual)', num: 2, total: 5 },
  { slug: 'model',       title: 'Inbound / Outbound',     num: 3, total: 5 },
  { slug: 'commissions', title: 'Commission rates',       num: 4, total: 5 },
  { slug: 'done',        title: 'Confirmation',           num: 5, total: 5 },
];

export const STEPS_BY_PERSONA: Record<Persona, StepDef[]> = {
  client:  CLIENT_STEPS,
  talent:  TALENT_STEPS,
  partner: PARTNER_STEPS,
};

export function nextStep(persona: Persona, currentSlug: string): string | null {
  const list = STEPS_BY_PERSONA[persona];
  const i = list.findIndex((s) => s.slug === currentSlug);
  if (i < 0 || i + 1 >= list.length) return null;
  return list[i + 1].slug;
}

export function prevStep(persona: Persona, currentSlug: string): string | null {
  const list = STEPS_BY_PERSONA[persona];
  const i = list.findIndex((s) => s.slug === currentSlug);
  if (i <= 0) return null;
  return list[i - 1].slug;
}
